import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import General from 'components/OrderEditMain';
import EntityHistory from 'components/EntityHistory';

import { OrderEditTabs_order$key } from '__generated__/OrderEditTabs_order.graphql';

type Props = {
  order: OrderEditTabs_order$key;
};

const OrderEditTabs: FC<Props> = props => {
  const order = useFragment(
    graphql`
      fragment OrderEditTabs_order on Order {
        ...OrderEditMain_order
        ...EntityHistory_entity
      }
    `,
    props.order
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          hash: 'general',
          component: <General order={order} />,
        },
        {
          title: 'Istorija',
          hash: 'history',
          component: <EntityHistory entity={order} />,
        },
      ]}
    />
  );
};

export default OrderEditTabs;
